import useTheme from '../../utilities/hooks/theme';
import { isSmartPhone } from '../../utilities/helper';
import React from 'react';
import FooterMWeb from './index_mWeb';
import FooterWeb from './index_web';

const Footer = () => {
  const { DashboardTheme: theme } = useTheme();
  const footerBackground = {
    background: theme.footerBackground,
    borderTop: isSmartPhone ? '' : `1px solid ${theme.footerBorder}`
  };
  const props = {
    footerBackground: footerBackground
  };
  return (
    <React.Fragment>
      {isSmartPhone ? <FooterMWeb {...props} /> : <FooterWeb {...props} />}
    </React.Fragment>
  );
};

export default Footer;
